export default __webpack_public_path__ + "static/media/317.9aae3250.jpg";